export const CHAT_HISTORY_STORAGE_PREFIX = 'amia_chat';
